import type { FounderParams, FounderReturn } from '../types';
import { formatUSPCardTextContent } from '../helpers';

export default function (params: FounderParams): FounderReturn {
  const { _editable, _uid, text, subText, image } = params;
  return {
    _editable,
    _uid,
    module: 'SFounder',
    component: 'SFounder',
    subText: formatUSPCardTextContent(subText[0]),
    text: formatUSPCardTextContent(text[0]),
    image: image[0]
  };
}
